import { TravisPrintOne } from "../../../../src/content/posts/2020-08-25-handwriting-font/travis-print-one";
import * as React from 'react';
export default {
  TravisPrintOne,
  React
};